import React from 'react';
import ReactECharts from 'echarts-for-react'; 
import './index.scss';


const ActivitiesByModality = (props) => {
     
    const { modalityChartData, visits,activityChart } = props;
    const [newModalityOption, setNewModalityOption] = React.useState({});

    const modalityOption = {
      title:{
        show:false,
        text: 'Activities by modality',
        x:'center',
        y:'top',
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold',
          color: '#333'
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          // Use axis to trigger tooltip
          type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
        },
        confine:false,
        position: ['100%', '-10%']
      },
      grid: {
        left: '10%',
        right: '4%',
        top: '15%',
        bottom: '8%',
        containLabel: true
      },
      xAxis: {
        name: 'Visit number',
        nameLocation: "middle",
        type: 'category',
        data: visits,
        nameRotate: 0, nameGap: 20,
      },
      yAxis: {
          type: 'value'
      },
      series:modalityChartData||[]
    };

    const emptyOption = {
      title:{
        show:false,
      },
      grid: {
        left: '10%',
        right: '4%',
        top: '15%',
        bottom: '8%',
        containLabel: true
      },
      xAxis: {
        name: 'Visit number',
        nameLocation: "middle",
        type: 'category',
        data: [],
        nameRotate: 0, 
        nameGap: 20,
      },
      yAxis: {
          type: 'value'
      },
      series:[]
    };

    React.useEffect(() => {    
      if (visits?.length > 0 && modalityChartData?.length > 0) {
          setNewModalityOption(modalityOption);
      } else {
        setNewModalityOption(emptyOption);
      }
    },[modalityChartData, visits])

  
    return (
        <div  style={{  marginLeft: "50px", verticalAlign: "top"}} > 
            <ReactECharts  
            key={JSON.stringify(newModalityOption)} 
            option={newModalityOption} 
            style={{ width: '80%',  height: '400px'}}
            onChartReady={()=> activityChart(false)}/>
        </div> 
    );
  };
  
  export default ActivitiesByModality;